export const selectLanguages = (state) => state.awarenessCenter?.campaigns.languages

export const selectCampaignsSettings = (state) => state.awarenessCenter?.campaignsSettings
export const selectDefaultCampaignFailedAlertContent = (state) =>
  state.awarenessCenter?.campaignsSettings.data.defaultCampaignFailedAlertContent
